import { BaseButton } from '@/src/components/buttons/BaseButton'
import { useReportDetailChatSidebarStore } from '@/src/features/Reports/stores/useReportDetailChatSidebar.store'
import { useSessionStore } from '@/src/hooks/use_session_store'
import { appColors } from '@/src/theme'
import { FlexCol, FlexRow } from '@components'
import { useNavbarCollapsedStore } from '@shared/infrastructure/useNavbarCollapsedStore'
import { NAVBAR_COLLAPSED_WIDTH, NAVBAR_WIDTH } from '@utils/constants'
import type { FC } from 'react'
import { LuPanelLeft } from 'react-icons/lu'
import { useEmberStore } from '../../features/Ember/infrastructure/useEmberStore'
import { CompanySelect } from './CompanySelect/CompanySelect'
import { NavbarEcoplanetLogo } from './NavbarEcoplanetLogo'
import { NavbarWhiteLabelLogo } from './NavbarWhiteLabelLogo'

type NavbarProps = {
  children: React.ReactNode
  isSubNavbar?: boolean
}

const NavbarHeader = ({ isCollapsed, uncollapse }) => {
  const marginLeft = isCollapsed ? 2 : 5
  return (
    <FlexRow marginLeft={marginLeft} marginBottom={7}>
      <FlexRow alignItems={'center'} justifyContent={'space-between'} width={'100%'} pr={isCollapsed ? undefined : '22px'}>
        <CompanySelect />

        <BaseButton
          variant='secondary'
          data-testid='navbar-collapse-button'
          bg='white'
          p='4px'
          h='24px'
          zIndex={50}
          borderRadius={'4px'}
          cursor={'pointer'}
          onClick={uncollapse}
          // transform={isCollapsed ? 'translateX(20px)' : 'none'}
          transform={'translateX(8px)'}
          _active={{ transform: 'translateX(8px)' }}
        >
          <LuPanelLeft color='#0D0D0D' />
        </BaseButton>
      </FlexRow>
    </FlexRow>
  )
}

export const Navbar: FC<NavbarProps> = ({ children, isSubNavbar }) => {
  const emberStore = useEmberStore()
  const [isReportChatOpen, closeReportChat] = useReportDetailChatSidebarStore(state => [state.isOpen, state.closeChat])
  const { isCollapsed: isMainNavbarCollapsed, toggleCollapsedMode } = useNavbarCollapsedStore()
  const isCollapsed = !isSubNavbar && isMainNavbarCollapsed

  const { user } = useSessionStore()
  const companyId = user?.company.id
  const whiteLabelLogoId = user?.company.whiteLabelLogoId

  const uncollapse = () => {
    if (emberStore.isSidebarShowing) {
      emberStore.toggleSidebar()
    }
    if (isReportChatOpen) {
      closeReportChat()
    }
    toggleCollapsedMode()
  }

  return (
    <FlexCol
      id={isSubNavbar ? 'subnavbar' : 'navbar'}
      borderRightWidth={'1px'}
      borderRightColor={'border'}
      bg={appColors.muted}
      py='12px'
      width={isCollapsed ? NAVBAR_COLLAPSED_WIDTH : NAVBAR_WIDTH}
      height='100%'
    >
      {!isSubNavbar && <NavbarHeader uncollapse={uncollapse} isCollapsed={isCollapsed} />}
      {children}
      {!isSubNavbar && !!whiteLabelLogoId && !isCollapsed && (
        <NavbarWhiteLabelLogo companyId={companyId} whiteLabelLogoId={whiteLabelLogoId} />
      )}
      {!isSubNavbar && <NavbarEcoplanetLogo uncollapse={uncollapse} isCollapsed={isCollapsed} />}
    </FlexCol>
  )
}
